import store from '@/store/index.js'
let dic = store.state.dic;

import { validateMoneyCorrect, validatePhoneCorrect } from "@/libs/elementChecker.js";

export default function Configs(that) {

    const formItems = [
        {
            span: 4,
            label: "学习(工作)起始日期",
            model: "startTime",
            type: 'date',
        },
        {
            span: 4,
            label: "学习(工作)终止日期",
            model: "endTime",
            type: 'date',
        },
        {
            label: "学习(社会工作)部门",
            span: 4,
            model: "unit",
            placeholder: '请输入',
        },
        {
            label: "学习(社会工作)职务",
            span: 4,
            model: "job",
        },
        {
            label: "证明人姓名",
            span: 4,
            model: "verifyName",
            placeholder: '请输入',
        },
        {
            label: "证明人职务",
            span: 3,
            model: "verifyJob",
        },
        // {
        //     label: "备注",
        //     span: 2,
        //     model: "remark",
        // },
    ]




    const formRules = {
        unit: [{
            required: true,
            message: "请输入学习(社会工作)部门",
            trigger: "blur"
        }],
        job: [{
            required: true,
            message: "请输入学习(社会工作)职务",
            trigger: "blur"
        }],
        startTime: [{
            required: true,
            message: "请选择起始日期",
            trigger: "chagne"
        }],
        endTime: [{
            trigger: "chagne",
            message: "请选择终止日期",
            required: true,
        }],
        verifyName: [{
            trigger: "blur",
            message: "请输入证明人姓名",
            required: true,
        }],
        verifyJob: [{
            trigger: "blur",
            message: "请输入证明人职务",
            required: true,
        }],
    }

    return {
        formItems,
        formRules,
    }
}
